import React from 'react';
import { FlaskConical } from 'lucide-react';

const ABTestTab = ({ abResults }) => (
  <div className="abtest-section" data-testid="abtest-dashboard">
    <div className="abtest-header-card">
      <h2 className="section-heading">A/B Test: Hero Headline</h2>
      <p className="abtest-desc">Membandingkan 2 varian headline untuk mengoptimalkan conversion rate.</p>
    </div>

    {abResults && (
      <>
        <div className="abtest-summary">
          <span>Total visitors: <strong>{abResults.total_visitors}</strong></span>
          {abResults.winner && <span className="abtest-winner">Pemenang sementara: <strong>Varian {abResults.winner}</strong></span>}
        </div>
        <div className="abtest-variants">
          {['A', 'B'].map((v) => {
            const data = abResults.variants?.[v];
            if (!data) return null;
            const isWinner = abResults.winner === v;
            return (
              <div key={v} className={`abtest-variant-card ${isWinner ? 'winner' : ''}`} data-testid={`abtest-variant-${v}`}>
                <div className="abtest-variant-header">
                  <span className="abtest-variant-label">Varian {v}</span>
                  {isWinner && <span className="abtest-winner-badge">Leader</span>}
                </div>
                <p className="abtest-variant-preview">{data.content_preview}</p>
                <div className="abtest-variant-stats">
                  <div className="abtest-stat"><span className="abtest-stat-value">{data.visitors}</span><span className="abtest-stat-label">Visitors</span></div>
                  <div className="abtest-stat"><span className="abtest-stat-value">{data.conversions}</span><span className="abtest-stat-label">Conversions</span></div>
                  <div className="abtest-stat accent"><span className="abtest-stat-value">{data.conversion_rate}%</span><span className="abtest-stat-label">Rate</span></div>
                </div>
              </div>
            );
          })}
        </div>
      </>
    )}

    {!abResults?.total_visitors && (
      <div className="scheduler-empty">
        <FlaskConical size={48} />
        <p>A/B test aktif — menunggu data visitor.</p>
        <p className="scheduler-hint">Setiap pengunjung secara acak melihat Varian A atau B. Data konversi akan tercatat otomatis.</p>
      </div>
    )}
  </div>
);

export default ABTestTab;
